<script setup>
// Prévia gerada pelo SERVIDOR (o HTML que vai no envio), em computador,
// celular e modo escuro. Iframe sem scripts.
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { useAlert } from 'dashboard/composables';
import API from 'dashboard/api/marketingEmailTemplates';

const props = defineProps({ source: { type: Function, required: true } });
const { t } = useI18n();
const dialog = ref(null);
const html = ref('');
const sizeKb = ref(0);
const device = ref('desktop');
const dark = ref(false);
const loading = ref(false);

let requestId = 0;
const refresh = async () => {
  requestId += 1;
  const mine = requestId;
  loading.value = true;
  try {
    const { data } = await API.preview(props.source(), { dark: dark.value });
    if (mine !== requestId) return;
    html.value = data.html;
    sizeKb.value = data.size_kb;
  } catch (error) {
    if (mine === requestId) {
      useAlert(
        error?.response?.data?.error ||
          t('EMAIL_TEMPLATES.EDITOR.PREVIEW_ERROR')
      );
    }
  } finally {
    if (mine === requestId) loading.value = false;
  }
};
const open = () => {
  dialog.value?.open();
  refresh();
};
watch(dark, refresh);
defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialog"
    :title="t('EMAIL_TEMPLATES.EDITOR.TOPBAR.REAL_PREVIEW')"
    :show-confirm-button="false"
    width="5xl"
    overflow-y-auto
  >
    <div class="flex items-center gap-2">
      <div class="flex gap-0.5 rounded-lg border border-n-weak p-0.5">
        <button
          v-for="d in ['desktop', 'mobile']"
          :key="d"
          type="button"
          class="rounded-md px-2 py-1 text-xs"
          :class="
            device === d ? 'bg-n-brand/10 text-n-brand' : 'text-n-slate-11'
          "
          @click="device = d"
        >
          {{ t(`EMAIL_TEMPLATES.EDITOR.TOPBAR.${d.toUpperCase()}`) }}
        </button>
      </div>
      <button
        type="button"
        class="rounded-md px-2 py-1 text-xs"
        :class="dark ? 'bg-n-brand/10 text-n-brand' : 'text-n-slate-11'"
        @click="dark = !dark"
      >
        {{ t('EMAIL_TEMPLATES.EDITOR.TOPBAR.DARK') }}
      </button>
      <span class="ml-auto text-xs text-n-slate-10">{{
        t('EMAIL_TEMPLATES.BUILDER.PREVIEW.SIZE', { kb: sizeKb })
      }}</span>
    </div>
    <div
      class="flex justify-center rounded-lg bg-n-solid-2 p-4"
      :class="{ 'opacity-60': loading }"
    >
      <iframe
        sandbox=""
        class="h-[70vh] rounded-md border-0 bg-white shadow"
        :style="{ width: device === 'mobile' ? '375px' : '100%' }"
        :srcdoc="html"
      />
    </div>
  </Dialog>
</template>
